import React, { useState } from "react";
import { Container } from "../../components/container";

const FAQ_ITEMS = [
  {
    id: 1,
    question: "Can I use the League Life App for all 30 NBA markets?",
    answer:
      "Yes, once you become a League Life member you have access all of the service providers by category for all 30 NBA markets.",
  },
  {
    id: 2,
    question:
      "Is my information and search history private on the League Life App? Will you share my information with anyone?",
    answer:
      "Yes, League Life has gone to great lengths to make sure that we provide the highest level of security and privacy for our members. Information will not be shared with anyone.",
  },
  {
    id: 3,
    question: "Can I recommend a business to be listed on the League Life App?",
    answer:
      'Yes, we would love to hear from you! On your profile page simply click "Make a Suggestion" and we will check it out.',
  },
  {
    id: 4,
    question:
      "How Can I Provide Feedback, Comments Or Reviews About A Business Listed On League Life?",
    answer:
      "If you click on any service provider you will be able to add “comments” on their page within the app. Comments will be reviewed by the League Life staff before being posted.",
  },
  {
    id: 5,
    question: "Why Should I Become A League Life Member?",
    answer:
      "League Life is here to help! We are a resource guide for all things in your city. Whether you are just moving or have lived in the same place for years we will make it super easy to find resources for the every day needs in your life.",
  },
  {
    id: 6,
    question: "Who Is Able To Become A League Life Member?",
    answer:
      "League Life is a private and exclusive membership app available only to individuals employed by an NBA organization and their families.",
  },
  {
    id: 7,
    question: "Is League Life Free?",
    answer:
      "There is no fee at this time to be a member of the League Life community.",
  },
  {
    id: 8,
    question: "Can I Invite Other People To Become A League Life Member?",
    answer:
      "Individuals employed by a NBA organization will be invited to become a member of League Life and be able to share that access with 2 individuals of their choice. The invitation to join will have to come from the employee of the NBA organization.",
  },
  {
    id: 9,
    question:
      "If I Want To Find Out More About Sponsorship Or Partnership Opportunities With League Life Who Should I Contact?",
    answer:
      "We would love to hear from you! Please email info@leaguelife.com and we will make sure to get you to the proper contact.",
  },
  {
    id: 10,
    question:
      "If I Have A Technical Problem Or Issue With The App Who Can I Contact?",
    answer:
      "Please let us know right away if you experience any technical issues by emailing info@leaguelife.com",
  },
];

function Faq() {
  const [openId, setOpenId] = useState<number | null>(2);

  const toggleItem = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section
      className="bg-white mt-20"
      id="faq"
      aria-label="Frequently asked questions"
    >
      <Container>
        <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] text-center mb-12">
          FAQ
        </h2>
      </Container>

      <div className="max-w-4xl mx-auto">
        <Container>
          {FAQ_ITEMS.map((item, index) => (
            <article
              key={item.id}
              itemScope
              itemType="https://schema.org/Question"
            >
              <div className="w-screen relative left-[50%] right-[50%] -ml-[50vw] -mr-[50vw] border-t border-gray-300" />
              <button
                onClick={() => toggleItem(item.id)}
                className="w-full py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                aria-expanded={openId === item.id}
                aria-controls={`faq-answer-${item.id}`}
              >
                <h3
                  className="text-2xl font-bold text-black pr-8"
                  itemProp="name"
                >
                  {item.question}
                </h3>
                <span className="text-2xl flex-shrink-0" aria-hidden="true">
                  {openId === item.id ? "▲" : "▼"}
                </span>
              </button>
              {openId === item.id && item.answer && (
                <div
                  id={`faq-answer-${item.id}`}
                  className="pb-6"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    className="text-2xl text-[#3E3E3E] leading-[120%]"
                    itemProp="text"
                  >
                    {item.answer}
                  </p>
                </div>
              )}
              {index === FAQ_ITEMS.length - 1 && (
                <div className="w-screen relative left-[50%] right-[50%] -ml-[50vw] -mr-[50vw] border-t border-gray-300" />
              )}
            </article>
          ))}
        </Container>
      </div>
    </section>
  );
}

export { Faq };
